 export class loadingTutorial{
    constructor(){
    }
        /*constructor(baseURL: string, bannerURL: string, logoURL?: string, footerURL?: string, gsm?: any) {
            //this.baseurl = baseURL;
            //this.init(bannerURL, logoURL, footerURL);
        }*/

    public dispatchInitTutorial(language: string, gameId: string, parentDivId: string, callback: () => void) {
        window.dispatchEvent(new CustomEvent("initLoadingTutorialPage", {
            detail: { language, gameId, parentDivId, callback }
        }));
    }

    public dispatchShowLoading() {
        window.dispatchEvent(new CustomEvent("showLoading"));
    }

    public updateProgress(percent: number) {
        let gsmLoadingUpdateEvent = new CustomEvent('gsmLoadingUpdate', { detail: { percent } });
        window.dispatchEvent(gsmLoadingUpdateEvent);

        if (percent == 100) {
            // dispatch the gsmLoadingComplete event to hide the progress bar
            let gsmLoadingCompleteEvent = new CustomEvent('gsmLoadingComplete', {  });
            window.dispatchEvent(gsmLoadingCompleteEvent);
        }
    }

    public dispatchShowContinueButton(callback: () => void, buttonText: string = "") {
        window.dispatchEvent(new CustomEvent("showContinueButton", {
            detail: { callback, buttonText }
        }));
    }

    public hideLoadingScene() {
        window.dispatchEvent(new CustomEvent("hideLoading"));
        //Serve al GSM per capire che è il tutorial è stato chiuso e può partire il timer del timeout client
        window.dispatchEvent(new CustomEvent("tutorialFinished"));
    }
}
